import common from "./pt-PT/common";
import validations from "./pt-PT/validations.json";
import navbar from "./pt-PT/navbar.json";
import post from "./pt-PT/post.json";

export const resources = {
    pt: {
        common,
        validations,
        navbar,
        post
    },
};

export default resources;